import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=0054f083&scoped=true"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=0054f083&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054f083",
  null
  
)

export default component.exports